// extracted by mini-css-extract-plugin
module.exports = {"post__container":"Post_post__container__2Fcqf","post__overlay":"Post_post__overlay__1mXrp","post":"Post_post__1CH5C"};